import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

const BottomBarDataPortal = props => {
  const { children, beforeClose } = props;
  const elRef = useRef(null);

  if (!elRef.current && typeof document !== 'undefined') {
    elRef.current = document.createElement('div');
  }

  useEffect(() => {
    const barRoot = document.getElementById('bottom-bar-content');
    const el = elRef.current;

    if (!barRoot || !el) return undefined;

    barRoot.appendChild(el);

    return () => {
      beforeClose && beforeClose();
      if (el.parentNode === barRoot) {
        barRoot.removeChild(el);
      }
    };
  }, [beforeClose]);

  if (!elRef.current) return null;

  return createPortal(children, elRef.current);
};

BottomBarDataPortal.propTypes = {
  children: PropTypes.node.isRequired,
  beforeClose: PropTypes.func
};

export default BottomBarDataPortal;
